import './RegisterPage.css'
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

import MainLogo from '../../mainlogo.png';

const RegisterPage = () => {
  const [name, setName] = useState('');  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const [modalTitle, setModalTitle] = useState('');


  const { user } = useAuth();
  const navigate = useNavigate();

  if (user) {
    navigate('/');
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const registerData = {
      name: name,
      email: email,
      password: password
    };
  
    axios.post(
      '/api/v0/register',
       registerData, {},
    )
      .then(response => {
        if (response.data.code == 200) {
          setModalText(response.data.message);
          setModalTitle('Следующее действие');
          setShowModal(true);
        } else {
          setModalText(response.data.message);
          setModalTitle('Ошибка');
          setShowModal(true);
        }
      })
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <form onSubmit={handleSubmit} class="h-100 d-flex flex-column align-items-center justify-content-center" style={{maxWidth: '50%', margin: 'auto'}}>
      <img class="mb-4" src={MainLogo} style={{maxWidth: "300px", marginTop: "30px"}}></img>
        <h1 class="h3 mb-3 font-weight-normal">Форма регистрации</h1>
        <label for="inputName" class="sr-only">Имя</label>
        <input 
          type="username" 
          id="inputName" 
          value={name}
          onChange={(e) => setName(e.target.value)}
          class="form-control" 
          placeholder="Имя" 
          required 
          autofocus
        />
        <label for="inputEmail" class="sr-only">Email address</label>
        <input 
          type="email" 
          id="inputEmail" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          class="form-control" 
          placeholder="Email address" 
          required 
          autofocus
        />
        <label for="inputPassword" class="sr-only">Password</label>
        <input 
          type="password" 
          id="inputPassword"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          class="form-control" 
          placeholder="Password" 
          required
        />
        {/* <div class="checkbox mb-3">
          <label>
            <input type="checkbox" value="remember-me" /> Remember me
          </label>
        </div> */}
        <button class="btn btn-lg btn-dark btn-block" type="submit">Создать аккаунт</button>
      </form>
      <div className={`modal ${showModal ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: showModal ? 'block' : 'none' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{modalTitle}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleCloseModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{modalText}</p>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default RegisterPage;
